import type { AuthTokens } from '@data';
import { handleError, logError } from '@utils-global';
import { handleDialogAPIErrors } from './handleDialogAPIErrors';
import { DialogOpenError, loginWithDialogAPI } from './loginWithDialogAPI';

type AuthenticateWithDialogParams = {
  userEmail: string;
  onTokens: (tokens: AuthTokens) => void;
  showToast: (translationKey: string, options?: unknown) => void;
};

export const authenticateWithDialog = async (params: AuthenticateWithDialogParams) => {
  const { showToast } = params;

  try {
    await loginWithDialogAPI(params);
  } catch (error) {
    if (error instanceof DialogOpenError) {
      logError('Failed to open login dialog', { error });
      handleDialogAPIErrors(error, showToast);
      return;
    }

    handleError(error, () => handleDialogAPIErrors(error, showToast));
  }
};
